// src/NeuroGlintPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";
import "./NeuroGlintPage.css";

function Hero() {
  return (
    <section
      className="hero"
      style={{ backgroundImage: "url(/img/fondoNeuroG3.jpg)" }}
      data-aos="fade-in"
    >
      <div className="container hero__content" data-aos="fade-up" data-aos-delay="200">
        <img
          src="/img/neuroglintLogo.png"
          alt="NeuroGlint Logo"
          className="hero__logo"
          data-aos="zoom-in"
          data-aos-delay="400"
        />
        <h1 data-aos="fade-up" data-aos-delay="600">
          Entiende lo que sienten. <br /> Actúa con inteligencia.
        </h1>
        <p data-aos="fade-up" data-aos-delay="800">
          NeuroGlint es un sistema avanzado de análisis emocional y
          comportamental que combina neurociencia aplicada, inteligencia
          artificial y realidad virtual para transformar emociones en datos
          estratégicos. Toma decisiones informadas basadas en lo que realmente
          sienten las personas.
        </p>
        <div className="welcome-buttons" data-aos="fade-up" data-aos-delay="1000">
          <Link to="/contacto" className="sparkling-btn btn-purple-pink font-bold">
            <div className="sparkling-btn-border" />
            <div className="sparkling-btn-content">
              Solicita una demo
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

function Seccion({ id, title, children, imgPath, imgAlt, reverse }) {
  return (
    <section
      id={id}
      className={`container seccion ${reverse ? "seccion--reverse" : ""}`}
      data-aos="fade-up"
    >
      <div className="seccion__texto" data-aos="fade-right">
        <h2>{title}</h2>
        {children}
      </div>
      {imgPath && (
        <div className="seccion__imagen" data-aos="fade-left" data-aos-delay="200">
          <img src={imgPath} alt={imgAlt} />
        </div>
      )}
    </section>
  );
}

function Beneficios() {
  const items = [
    {
      img: "/img/cerebrp.png",
      alt: "Icono experiencia del cliente",
      title: "Mejora la experiencia del cliente",
      text: "Comprende cómo las personas realmente perciben los productos o servicios.",
    },
    {
      img: "/img/carafeliz.png",
      alt: "Icono optimiza la toma de decisiones",
      title: "Optimiza la toma de decisiones",
      text: "Se basa en estrategias de datos emocionales reales, no solo en suposiciones.",
    },
    {
      img: "/img/altavoz.png",
      alt: "Icono investigación avanzada",
      title: "Investigación avanzada en comportamiento humano",
      text: "Aporta rigor científico a estudios de mercado, experiencia de usuario y marketing.",
    },
    {
      img: "/img/info.png",
      alt: "Icono aplicaciones en múltiples sectores",
      title: "Aplicaciones en múltiples sectores",
      text: "Como la salud, el retail, el turismo o la agricultura.",
    },
  ];

  return (
    <section id="beneficios" className="container" data-aos="fade-up">
      <h2 data-aos="fade-right">Beneficios</h2>
      <div className="cards">
        {items.map((b, i) => (
          <div
            key={i}
            className="card"
            data-aos="zoom-in"
            data-aos-delay={200 + i * 100}
          >
            <div className="card-image">
              <img src={b.img} alt={b.alt} />
            </div>
            <h3>{b.title}</h3>
            <p>{b.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function ComoFunciona() {
  const [lightboxImg, setLightboxImg] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 600, once: true, disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches });
  }, []);

  const steps = [
    {
      img: "/img/diseñoEntorno.png",
      title: "Diseño del entorno virtual",
      desc:
        "Creamos experiencias inmersivas y a medida según los objetivos de análisis."
    },
    {
      img: "/img/capturaDatos.png",
      title: "Captura de datos neurofisiológicos",
      desc:
        "Registramos mirada, microexpresiones y otras señales en tiempo real."
    },
    {
      img: "/img/IAneuroglint.png",
      title: "Análisis con IA",
      desc:
        "Interpretamos datos en vivo, generando insights emocionales y comportamentales."
    },
    {
      img: "/img/informe.png",
      title: "Informe estratégico",
      desc:
        "Entregamos resultados claros y accionables para optimizar productos y campañas."
    }
  ];

  return (
    <section
      id="como-funciona"
      className="container timeline-section neuroglint-page"
      data-aos="fade-up"
    >
      <h2 data-aos="fade-right">Cómo funciona</h2>
      <div className="timeline-steps">
        {steps.map((s, i) => (
          <div
            key={i}
            className="timeline-step"
            data-aos="fade-up"
            data-aos-delay={i * 150}
          >
            {/* Texto encima si es paso 1 y 3 */}
            {i % 2 === 0 && (
              <div className="step-body">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            )}

            {/* Imagen clicable en la línea */}
            <div
              className="step-img"
              onClick={() => setLightboxImg(s.img)}
              style={{ cursor: "pointer" }}
            >
              <img src={s.img} alt={s.title} />
            </div>

            {/* Texto debajo si es paso 2 y 4 */}
            {i % 2 === 1 && (
              <div className="step-body">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Lightbox overlay */}
      {lightboxImg && (
        <div className="lightbox" onClick={() => setLightboxImg(null)}>
          <button
            className="lightbox__close"
            onClick={() => setLightboxImg(null)}
          >
            ×
          </button>
          <img
            className="lightbox__img"
            src={lightboxImg}
            alt="Ampliado"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}

function CasosUso() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 500, once: true, disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches });
  }, []);

  const casos = [
    {
      icon: "/img/lupaNeuroglint.png",
      title: "Estudios de mercado y UX",
      desc:
        "Analizamos el comportamiento y la percepción de usuarios para optimizar experiencias digitales."
    },
    {
      icon: "/img/cerebrp.png",
      title: "Salud mental y educación emocional",
      desc:
        "Monitorizamos respuestas emocionales para diseñar programas de bienestar y formación adaptada."
    },
    {
      icon: "/img/sonrisa.png",
      title: "Agricultura, Turismo experiencial y retal emocional.",
      desc:
        "Creamos entornos inmersivos que maximizan la conexión emocional con marcas y destinos."
    }
  ];

  const toggle = (i) =>
    setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="casos-uso" className="casos-uso neuroglint-page">


      {/* 2ª fila: acordeón dentro de container */}
      <div className="container">
              {/* 1ª fila: título directo en la sección */}
      <h2 data-aos="fade-right">Casos de uso</h2>
        <div className="accordion">
      {casos.map((c,i) => (
        <div
          key={i}
          className={`accordion-item ${openIndex===i?"open":""}`}
          data-aos="fade-up"
          data-aos-delay={i*100}
        >
          <button
            className="accordion-header"
            onClick={()=>toggle(i)}
          >
            <div className="accordion-title-group">
              <img src={c.icon} className="accordion-header-icon" alt="" />
              <span className="accordion-header-text">{c.title}</span>
            </div>
            <span className="icon">
              {openIndex===i?"−":"+"}
            </span>
          </button>
          <div className="accordion-content">
            <p>{c.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
  );
}


function Contacto() {
  return (
    <section id="contacto" className="container contacto" data-aos="fade-up">
      <h2>Quiero implementar NeuroGlint</h2>
      <div className="welcome-buttons">
        <Link to="/contacto" className="sparkling-btn btn-purple-pink font-bold">
          <div className="sparkling-btn-border" />
          <div className="sparkling-btn-content">
            Solicita tu demo aquí
          </div>
        </Link>
      </div>
    </section>
  );
}

function NeuroGlintPage() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches });
    setTimeout(() => window.scrollTo(0, 0), 50);
  }, []);

  return (
    <div className="neuroglint-page">
      <Hero />

      <Seccion
        id="desafio"
        title="El desafío"
        imgPath="/img/neuroglintDesafio.png"
        imgAlt="Imagen desafío"
      >
        <h1>
          <strong>
            ¿Cómo saber lo que realmente piensan y sienten las personas?
          </strong>
        </h1>
        <p>
          Las emociones influyen en las decisiones más que las palabras.
          NeuroGlint revela las respuestas auténticas a través de datos
          neurofisiológicos, ayudando a empresas y profesionales a diseñar
          mejores experiencias, productos y estrategias.
        </p>
      </Seccion>

      <Seccion
        id="solucion"
        title="Nuestra solución"
        imgPath="/img/neuroglintSolucion.png"
        imgAlt="Imagen solución"
        reverse
      >
        <h1>
          <strong>NeuroGlint es una plataforma de neurociencia aplicada que integra inteligencia artificial, realidad virtual y análisis emocional para comprender cómo las personas perciben, sienten y deciden.</strong>
        </h1>
        <p>
          Diseñada como una herramienta científica y tecnológica, permite analizar en tiempo real el comportamiento no consciente de los usuarios a través de indicadores como la mirada, las reacciones emocionales y las decisiones tomadas en entornos inmersivos. Gracias a esta capacidad de observación profunda, NeuroGlint facilita la optimización de productos, experiencias y campañas, aportando datos objetivos que revelan lo que las personas realmente experimentan, más allá de lo que verbalizan. En definitiva, hace visible lo invisible, transformando las emociones y percepciones en información estratégica y medible.
        </p>
      </Seccion>

      <Beneficios />
      <ComoFunciona />
      <CasosUso />
      <Contacto />

    </div>
  );
}

export default NeuroGlintPage;
